
export const updateStatuses= {
  "paid": "paid",
  "cancelled": "cancelled",
  "timeout": "timeout",
  'complete': 'complete',
  "pending": "pending",
}
